import { makeStyles } from '@material-ui/core/styles';

const userStyles = makeStyles(theme => ({
  User: {
    backgroundColor: theme.palette.darkBlackAlfa,
    borderRadius: 5,
    left: '50%',
    maxWidth: 800,
    maxHeight: '85vh',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -45%)',
    width: '100%',
    '&__settings': {
      width: '100%',
      display: 'flex',
      '&__content': {
        flexGrow: 1,
        overflowY: 'auto',
        '&__spacer': {
          width: '100%',
          height: 40,
        },
      },
      '&__close': {
        position: 'absolute',
        top: 5,
        right: 5,
        '&__container': {
          backgroundColor: theme.palette.green,
          border: '1px solid',
          borderColor: theme.palette.white,
          borderRadius: '50%',
          width: 30,
          height: 30,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'color 0.25s, box-shadow 0.25s',
          '& svg': {
            width: 25,
            height: 25,
          },
          '&:hover': {
            color: theme.palette.white,
            boxShadow: '0 0 12px rgba(6, 182, 212, 0.3)',
          },
        },
      },
    },
    '&__wrapper': {
      display: 'flex',
      position: 'relative',
      '&__content': {
        paddingTop: 40,
        margin: 'auto',
        '&__container': {
          maxWidth: 'inherit',
          overflow: 'hidden',
        },
        '&__form-container': {
          maxHeight: 'calc(80vh - 5px)',
          maxWidth: 'calc(100vw - 5px)',
          marginBottom: 15,
          overflowY: 'auto',
          wordBreak: 'break-all',
          '&__form': {
            marginTop: theme.spacing(3),
            width: '100%', // Fix IE 11 issue.
          },
        },
      },
    },
    '&__dashboard': {
      top: '5vh',
      left: '5vw',
      position: 'fixed',
      maxWidth: 400,
      transform: 'none',
      minHeight: 620,
      '&--inline': {
        position: 'relative',
        width: '100%',
        padding: '10px 0',
      },
      '&__selected': {
        maxWidth: 500,
        height: 620,
        '&--display-none': {
          display: 'none',
        },
      },
    },
    '&__add-component': {
      backgroundColor: theme.palette.darkBlackAlfa,
      position: 'fixed',
      top: '50%',
      left: '50%',
      padding: 15,
      width: 'calc(100vw - 30px)',
      height: '80vh',
      maxWidth: 'initial',
      maxHeight: 'initial',
      transform: 'translate(-50%, -50%)',
      zIndex: 2000,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      borderRadius: 8,
    },
    '&__edit-component': {
      backgroundColor: theme.palette.darkBlackAlfa,
      position: 'fixed',
      top: '50%',
      left: '50%',
      padding: 15,
      width: 'calc(100vw - 30px)',
      height: '80vh',
      maxWidth: 'initial',
      maxHeight: 'initial',
      transform: 'translate(-50%, -50%)',
      zIndex: 2000,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      borderRadius: 8,
    },
    '&--flex-column': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
}));

export { userStyles };
